import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { Button, Checkbox, Input, Text } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import { Metric } from "../../../metric";
import { useSubmitHandler } from "./utils";
import styles from "./styles.pcss";
import { connector } from "./connector";
var cx = classNames.bind(styles);
var _InputForm = function _InputForm(_ref) {
  var setRequestStatus = _ref.setRequestStatus,
    requestStatus = _ref.requestStatus,
    email = _ref.email,
    setEmail = _ref.setEmail,
    emailPlaceholder = _ref.emailPlaceholder,
    buttonText = _ref.buttonText,
    agreeWithTerms = _ref.agreeWithTerms,
    invalidEmail = _ref.invalidEmail,
    enterEmail = _ref.enterEmail,
    linkUrl = _ref.linkUrl,
    personalData = _ref.personalData,
    backendUrl = _ref.backendUrl,
    setAnimate = _ref.setAnimate,
    animate = _ref.animate,
    iconRef = _ref.iconRef,
    agreeRules = _ref.agreeRules,
    setAgreeRules = _ref.setAgreeRules,
    onClick = _ref.onClick;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    errorText = _useState2[0],
    setErrorText = _useState2[1];
  var onSubmit = useSubmitHandler({
    email: email,
    enterEmail: enterEmail,
    invalidEmail: invalidEmail,
    setRequestStatus: setRequestStatus,
    setErrorText: setErrorText,
    backendUrl: backendUrl,
    setAnimate: setAnimate,
    iconRef: iconRef
  });
  return /*#__PURE__*/React.createElement("form", {
    className: cx('form', animate && 'animate'),
    onSubmit: onSubmit,
    "data-t-id": "SubscriptionForms-InputForm"
  }, /*#__PURE__*/React.createElement(Input, {
    className: cx('form__input'),
    error: errorText,
    onChange: function onChange(emailModel) {
      return setEmail(emailModel);
    },
    placeholder: emailPlaceholder,
    value: email,
    wrapperProps: {
      style: {
        paddingLeft: 0
      }
    }
  }), /*#__PURE__*/React.createElement(Button, {
    disabled: !agreeRules || requestStatus === 'processing',
    size: "m",
    type: "submit",
    view: !agreeRules || requestStatus === 'processing' ? 'secondary-invert' : 'primary'
  }, buttonText), /*#__PURE__*/React.createElement("div", {
    className: cx('form__agree-block')
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: agreeRules,
    disabled: requestStatus === 'processing',
    onChange: function onChange(checked) {
      return setAgreeRules(checked);
    },
    required: true
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
    color: "secondary",
    size: "xs"
  }, agreeWithTerms), /*#__PURE__*/React.createElement(Metric, {
    data: JSON.stringify({
      link_text: personalData,
      link_url: linkUrl
    }),
    events: {
      footerMetric: ['handleClickLink']
    },
    mode: "click"
  }), /*#__PURE__*/React.createElement(Text, {
    className: cx('form__agree-block-link'),
    onClick: onClick,
    role: "button",
    size: "xs",
    tagName: "a"
  }, personalData))));
};
export var InputForm = connector(_InputForm);